import { render, staticRenderFns } from "./VCountrySelect.vue?vue&type=template&id=df5b7fa8&"
import script from "./VCountrySelect.vue?vue&type=script&lang=js&"
export * from "./VCountrySelect.vue?vue&type=script&lang=js&"
import style0 from "./VCountrySelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/components/ui/v-icon/VIcon.vue').default})
